import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18nPipe } from '@delon/theme';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';

import type { PersonalAssistantManagementComponent } from '../personal-assistant-management.component';

@Component({
  selector: 'assistant-instances-view',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzButtonModule,
    NzInputModule,
    NzModalModule,
    NzSpinModule,
    NzTagModule,
    NzIconModule,
    NzEmptyModule,
    I18nPipe,
    TestIdDirective
  ],
  templateUrl: './assistant-instances-view.component.html',
  styleUrls: ['./assistant-instances-view.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class AssistantInstancesViewComponent {
  @Input({ required: true }) vm!: PersonalAssistantManagementComponent;
}
